/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".view-scene-pagination{position:absolute;pointer-events:none;left:0;top:0;bottom:0;right:0;display:-webkit-box;display:flex;-webkit-box-pack:justify;justify-content:space-between;-webkit-box-align:center;align-items:center;z-index:10;padding:8px}.view-scene-pagination>*{pointer-events:initial}.view-scene-pagination--center{-webkit-box-pack:center;justify-content:center;-webkit-box-align:end;align-items:flex-end}"];
export { styles as styles };
